module.exports = __webpack_public_path__ + "img/unlock.10a32424.png";